import { render, staticRenderFns } from "./DraftHistoryList.vue?vue&type=template&id=10d356cc&scoped=true"
import script from "./DraftHistoryList.vue?vue&type=script&lang=js"
export * from "./DraftHistoryList.vue?vue&type=script&lang=js"
import style0 from "./DraftHistoryList.vue?vue&type=style&index=0&id=10d356cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d356cc",
  null
  
)

export default component.exports